import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {BadgeComponent} from "../../../common/badge/badge.component";
import {CopyDirective} from "../../../../directives/copy.directive";
import {UserRequest} from "../../../../model/UserRequest";
import {FaqCategory} from "../../../../model/FaqCategory";

@Component({
    selector: 'app-user-request-detail',
    imports: [
        CommonModule,
        FaIconComponent,
        BadgeComponent,
        NgbTooltip,
        CopyDirective,
    ],
    templateUrl: './user-request-detail.component.html',
    styleUrls: ['./user-request-detail.component.css']
})
export class UserRequestDetailComponent {

  @Input()
  request: UserRequest;

  @Input()
  categories: FaqCategory[];

  @Input()
  crmUrl: string;

  getCategoryFromSlug(p: any): FaqCategory {
    return this.categories.find(c => {
      return c.slug.toLowerCase() === p.toLowerCase();
    });
  }

}
